export const getParentUrl = () => {
  if (
    window.location &&
    window.location.ancestorOrigins &&
    window.location.ancestorOrigins[0]
  ) {
    return window.location.ancestorOrigins[0];
  } else {
    return document.referrer || "/";
  }
};

export const sendMessage = (msg) => {
  if (window?.parent?.postMessage) {
    // we need to replace Infinity with "Infinity" because stringifying the message results in Infinity being replaced with null
    window.parent.postMessage(
      JSON.stringify(msg, postMessageReplacer),
      getParentUrl()
    );
  }
};

export const sendAnalyticsEvent = (event) => {
  const msg = {
    type: "Analytics",
    payload: {
      ...event,
    },
  };
  sendMessage(msg);
};

export const constructAddSelectionPayload = (selectionData) => {
  return {
    eventType: {
      id: "1",
      name: "Soccer",
    },
    competition: {
      id: selectionData.competitionId,
      name: selectionData.competitionName,
    },
    event: {
      id: selectionData.eventId,
      name: `${selectionData.homeTeamName} v ${selectionData.awayTeamName}`,
      openDate: selectionData.date,
    },
    market: {
      marketId: selectionData.selection.marketId,
      marketName: selectionData.selection.marketName,
      marketType: selectionData.selection.marketType,
      inplay: selectionData.selection.marketInplay,
    },
    runner: {
      selectionId: selectionData.selection.id,
      selectionName: selectionData.selection.name,
      winRunnerOdds: {
        decimal: selectionData.selection.oddsDecimal,
        numerator: Number(selectionData.selection.odds.split("/")[0]),
        denominator: Number(selectionData.selection.odds.split("/")[1]),
      },
    },
  };
};

export const generateFavouriteAnalyticsType = (favourites) => {
  // check that favourites is an object with markets and odds properties
  if (typeof favourites === "object" && favourites !== null) {
    if (favourites.markets && favourites.odds) return "All";
    if (favourites.markets) return "Markets";
    if (favourites.odds) return "Odds";
  }
  return "Unknown";
};

export const postMessageReplacer = (key, value) => {
  if (value === Infinity) return "Infinity";
  return value;
};

export const postMessageReviver = (key, value) => {
  if (value === "Infinity") return Infinity;
  return value;
};
